import React, { useContext, useState } from "react";
import "./webinarLandingPage.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import AbuotUs from "../../assets/images/new/media.png";
import Abuotws from "../../assets/images/new/media-two.png";
import "swiper/css";
import "swiper/css/navigation";

import batuk from "../../assets/images/new/fav-removebg-preview.png";
import whyChooseUsImg from "../../assets/images/new/whyChooseUs.png";
import DownloadApp from "../../Components/DownLoadApp/DownloadApp";
import { ContactUSApi } from "../../ApiServices/NewsLettter/NewsLetterApi";
import { useNavigate } from "react-router-dom";
import { ERROR_MESSAGES } from "../../Components/GlobalErrorMessage";
import LazySection from "../Home/LazySection";
import FAQSection from "../../Components/FAQSection/FAQ";
import mainLogo from "../../../src/assets/images/new/logo.png";
import { Helmet } from "react-helmet-async";
import { LoaderContext } from "../../AuthContext/AuthContext";
import { handleProceedRemainingPayment } from "../../Components/RazorPay/RazorPayFunction";
import axios from "axios";
import { BaseUrl } from "../../BaseUrl/BaseUrl";
import ComingSoonModal from "../../Components/ComingSoonModal";

const WebinarLandingPage = () => {
  const { setLoader } = useContext(LoaderContext);
  const slides = [
    {
      image: "../../assets/images/new/aboutPageImg.png",
      category: "Webinar Speaker",
      title: "Pandit Rajesh Guruji ",
      text: "inspiring minds with ancient wisdom and modern insights to lead a balanced and purposeful life.",
      progress: "85%",
      goal: "$23,000 Goals",
      donated: "$9,000 Donate",
      color: "#ffa415",
      shape: "assets/images/shapes/d-shape-1.png",
    },
    {
      image: "assets/images/donation/donation-1-2.jpg",
      category: "Webinar Speaker",
      title: "Pandit Rajesh Guruji ",
      text: "inspiring minds with ancient wisdom and modern insights to lead a balanced and purposeful life.",
      progress: "80%",
      goal: "$13,000 Goals",
      donated: "$5,000 Donate",
      color: "#ff5528",
      shape: "assets/images/shapes/d-shape-2.png",
    },
    // Add more slides here if needed
  ];
  const [Action, setAction] = useState([]);
  const [showSuccessPopUp, setShowSuccessPopUp] = useState(null);
  const navigate = useNavigate();
  const [contactData, setContactData] = useState({
    email: null,
    LastName: null,
    email: null,
    mobileNumber: null,
    Message: null,
  });

  const metaDataDetails = {
    MetaTitle: 'Ganeshotsav Puja Rituals Webinar | Myomnamo Complete Guide',
    MetaDescription: "Join Myomnamo's Ganeshotsav webinar! Learn the complete guide to Ganesh Puja rituals, traditions & tips for a blissful celebration.",
    OpenGraphTag: "Myomnamo Presents Webinar: Complete Guide to Ganeshotsav Puja Rituals",
    CanonicalTag: "https://www.myomnamo.com/webinar",

  }
  const [contactUsMsg, setContactUsMsg] = useState(false);
  const [error, setError] = useState(false);
  const [verified, setVerified] = useState(null);
  const [showComingSoonModal, setShowComingSoonModal] = useState(false);
  function onCaptchaChange(value) {

    setVerified(true);
  }

  const handleContactFormSubmit = () => {
    let isValid = false;
    if (
      contactData.fullName === "" ||
      contactData.fullName === undefined ||
      contactData.fullName === null ||
      contactData.LastName === "" ||
      contactData.LastName === "" ||
      contactData.LastName === "" ||
      contactData.mobileNumber === "" ||
      contactData.mobileNumber === undefined ||
      contactData.mobileNumber === null ||
      contactData?.mobileNumber?.length !== 10 ||
      // contactData.Message === "" ||
      // contactData.Message === undefined ||
      // contactData.Message === null ||
      contactData.email === "" ||
      contactData.email === undefined ||
      contactData.email === null
    ) {
      isValid = true;
      setError(true);
    } else if (
      contactData.email !== null &&
      !validateEmail(contactData.email)
    ) {
      isValid = true;
      setError(true);
    }

    const api_params = {
      fullName: contactData.fullName,
      LastName: contactData.LastName,
      email: contactData.email,
      mobileNumber: contactData.mobileNumber,
      Message: contactData.Message,
    };

    if (!isValid) {
      handleRazorpayPayment();
    }
  };


  const ContactUsAPI = async (api_params) => {
    //  
    try {
      const res = await ContactUSApi(api_params);

      if (res.ResponseMessage === "Success.") {
        // setContactUsMsg('Thank you for contacting us.')
        // setAction('Contact')
        // setShowSuccessPopUp(true);
        navigate("/thank-you", {
          state: { moduleName: "ContactUs" },
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const closeAll = () => {
    //  ;
    setShowSuccessPopUp(false);
    setInitialData();
  };

  const setInitialData = () => {
    setError(false);
    setContactData((prev) => ({
      ...prev,
      fullName: "",
      LastName: "",
      email: "",
      mobileNumber: "",
      Message: "",
    }));
  };
  //   const ContactUsAPI = (params) => {
  //     const templateParams = {
  //       Name: params.name,
  //       Email: params.email,
  //       "Mobile Number": params.mobileNo,
  //       message: params.message,
  //       //   to_name: "Velvet Admin",
  //       //   from_name: "Velvet mail service",
  //       //   receiver_email: "velvetgps@gmail.com",
  //     };

  //     emailjs
  //       .send(
  //         "service_wp19bkh", // Service ID
  //         "template_b9wrsrm", // Template ID
  //         templateParams, // Template Parameters
  //         "e5YUU5XlmWckFjZk_" // Public Key
  //       )
  //       .then(
  //         () => {
  //          
  //           setShowThanksModal(true);
  //         },
  //         (error) => {
  //           
  //         }
  //       );
  //   };

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const handleChange = (e) => {
    let { id, value } = e.target;

    if (id === "fullName" || id === "lastName") {
      value = value.replace(/[^a-zA-Z\s]/g, '');
      value = value.charAt(0).toUpperCase() + value.slice(1);
    }
    if (id === "mobileNumber") {
      value = value.charAt(0) >= '6' ? value.replace(/\D/g, '').slice(0, 10) : ''; // Only keep digits and slice to 10 digits
    }

    setContactData((prev) => ({ ...prev, [id]: value }));
  };

  const handleRazorpayPayment = async () => {

    let orderIDReturned = null

    const PlaceOrderResponse = await handleProceedRemainingPayment('51')

    setLoader(true)
    if (PlaceOrderResponse?.status === 1) {

      axios
        .post(`${BaseUrl}/Webinar/WebinarUser`, {
          Name: contactData.fullName,
          EmailID: contactData.email,
          WhatsappNumber: contactData.mobileNumber,
          WebinarFee: 51,
          PaymentStatus: true,
          TransactionID: PlaceOrderResponse?.razorpay_payment_id

        })
        .then((res) => {
          if (res) {


            orderIDReturned = res.data.ID;
            setLoader(false)
            // navigate("/thank-you", {
            //   state: { moduleName: "WebinarPage" },
            // });
            setInitialData()
            setShowComingSoonModal(true)
          }
        });
    } else if (PlaceOrderResponse?.status === 0) {
      setLoader(false)
      alert('Payment Failed !')
    }
  };

  const HandleJoinNowClicked = () => {
    window.open(
      "https://rzp.io/rzp/zuxHv7iu",
      "_blank"
    );
  };
  return (
    <>
      <Helmet>
        <title>{metaDataDetails?.MetaTitle}</title>
        <meta name="description" content={metaDataDetails?.MetaDescription} />
        <link rel="canonical" href={metaDataDetails?.CannonicalLink} />

        {/* Open Graph Tag */}

        {/* <!-- Open Graph tags --> */}
        <meta property="og:title" content={metaDataDetails?.OpenGraphTag} />
        <meta
          property="og:description"
          content="Celebrate Ganeshotsav with devotion & knowledge. Join our webinar to learn step-by-step Ganesh Puja rituals & traditions."
        />
        <meta property="og:image" content="" />
        <meta
          property="og:url"
          content={`https://www.myomnamo.com/webinar`}
        />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Myomnamo" />
        <meta property="og:locale" content="en_IN" />

        {/* <!-- Twitter Card tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={metaDataDetails?.MetaTitle} />
        <meta
          name="twitter:description"
          content={metaDataDetails?.MetaDescription}
        />


        <script>
          {`
            !function(f,b,e,v,n,t,s){
              if(f.fbq) return; 
              n=f.fbq=function(){n.callMethod ? 
              n.callMethod.apply(n,arguments) : n.queue.push(arguments)};
              if(!f._fbq) f._fbq=n;
              n.push=n; n.loaded=!0; n.version='2.0';
              n.queue=[]; t=b.createElement(e); t.async=!0;
              t.src=v; s=b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t,s)
            }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '24982247501377559');
            fbq('track', 'PageView');
          `}
        </script>
        <noscript>
          {`<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=24982247501377559&ev=PageView&noscript=1"/>`}
        </noscript>


      </Helmet>
      {/* <section className="about-three">
        <div className="sec-title text-center" style={{ paddingBottom: "0px" }}>
          <h6
            className="sec-title__tagline"
            style={{
              perspective: "400px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img className=" tagline-img" src={batuk} alt="" /> Webinar Topic:

         
          </h6>
          <h3
            className="sec-title__title"
            style={{
              perspective: "400px",
              textAlign: "center",
              marginBottom: "50px",
            }}
          >
         The webinar is divided in to below 2 topics.

          </h3>
        </div>
        <div className="container">
            
          <div className="row">
            <div className="col-lg-8 wow fadeInLeft" data-wow-delay="100ms">
              <div className="about-three__content">
               
                <p
                  className="about-three__content__text text-dark"
                  style={{ textAlign: "justify" }}
                >
                 <ul className="text-muted ps-4">
                        <li>The main rituals of Ganesh Chaturthi: Pranapratishhtha (invoking life into the idol), Shhodashopachara (16 types of offerings), Uttarpuja (farewell ritual), and Ganpati Visarjan (immersion of the idol).
</li>
                        <li>Step-by-step explanation of the puja vidhi, including significance and meanings behind each ritual gesture
</li>
                        
                      </ul>
                </p>
               
              </div>
            </div>
            <div className="col-lg-4">
              <div
                className=""
                data-wow-delay="200ms"
                style={{
                  paddingTop: "0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div className="about-three__image__shape-one">
                 
                </div>
                <img src={whyChooseUsImg} className="height2" alt="careox" />
                <div
                  className="about-three__image__right wow fadeInUp"
                  data-wow-delay="300ms"
                >
                 
                </div>
                <div className="about-three__image__shape-two">
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <section className="contact-section-custom py-5 mobile-secone">
        <div className="container">
          <div className="row align-items-center">
            {/* Left: Content */}
            <div
              className="col-lg-6 mb-4 mb-lg-0 wow fadeInLeft main-topicwebinar"
              data-wow-delay="100ms"
            >
              <div className="about-three__content">
                {/* Logo */}

                {/* Section Title */}
                <div
                  className="logo-webinarmarathi"
                  style={{ textAlign: "left" }}
                >
                  <img
                    src={mainLogo}
                    alt="मायओम नमो लोगो"
                    style={{ maxWidth: "194px", height: "auto" }}
                  />
                </div>
                <div className="sec-title main-time">
                  <h3 className="sec-title__title bw-split-in-left webinar-head">
                    माय ओम नमो प्रस्तुत वेबिनार २०२५
                  </h3>
                  <h6
                    className="sec-title__tagline bw-split-in-right mobile-heading"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      marginBottom: "7px",
                      marginTop: "13px",
                      color: "black",

                    }}
                  >
                    <strong className="marathi">विषय : </strong> गणेश उत्सव व
                    त्याचे महत्त्व
                  </h6>
                  <button type="submit" onClick={() => HandleJoinNowClicked()} className="careox-btn  mobile-but">
                    <span>नोंदणी करा</span>
                  </button>
                </div>

                {/* Content */}
                <div
                  className="about-three__content__text text-dark"
                  style={{ textAlign: "justify" }}
                >
                  <p className="webinarpara">
                    संपूर्ण भारतात पण विशेषतः महाराष्ट्र व त्याच्या आसपास च्या
                    राज्यात सगळ्यांना एकझुट करून आरतीच्या तालावर ठेका धरायला
                    लावणारा एकमेव सण म्हणजे गणेश उत्सव. प्रत्येक मराठी माणसाचा
                    हळवा कप्पा असणारा गणेश उत्सव भाद्रपद महिन्याच्या चतुर्थीला
                    येत असतो.
                  </p>
                  <ul className="webinar-list">
                    <li>
                      <strong>गणेश चतुर्थी :</strong> २७ ऑगस्ट २०२५
                    </li>
                    <li>
                      <strong>वेबिनार दिनांक :</strong> १८ ऑगस्ट २०२५
                    </li>
                    <li>
                      <strong>वेळ :</strong> सकाळी ११:०० ते दुपारी १:३०
                    </li>
                    <li>
                      <strong>भाषा :</strong> मराठी
                    </li>
                    <li>
                      <strong>शुल्क :</strong> ₹५१
                    </li>
                    <li>
                      <strong>प्लॅटफॉर्म :</strong> Zoom
                    </li>
                  </ul>

                  <button type="submit" onClick={() => HandleJoinNowClicked()} className="careox-btn button-webinar">
                    <span>नोंदणी करा</span>
                  </button>
                </div>
              </div>
            </div>

            {/* Right: Contact Form */}
            <div className="col-lg-6">
              <div className="form-card shadow-sm rounded bg-white padding-webinar">
                <div className="row gy-3">
                  {/* Logo */}
                  <h3 className="fw-bold mb-3 text-primary mane-webinarhead">
                    वेबिनारसाठी नोंदणी करा
                  </h3>

                  {/* First Name */}
                  <div className="col-md-12 col-webinarmarathimarathi">
                    <label className="form-label-custom webinar-label">
                      पूर्ण नाव <span>*</span>
                    </label>
                    <input
                      type="text"
                      id="fullName"
                      value={contactData?.fullName}
                      onChange={handleChange}
                      className="form-input webinar-form"
                      placeholder="पूर्ण नाव"
                    />
                    {error && (contactData?.fullName === null || contactData?.fullName === undefined || contactData?.fullName === "") ? <span className="text-danger" style={{ fontSize: '14px' }}>{ERROR_MESSAGES}</span> : ''}
                  </div>

                  {/* Last Name */}

                  {/* Mobile */}
                  <div className="col-md-6 col-webinarmarathi">
                    <label className="form-label-custom webinar-label">
                      व्हॉट्सअ‍ॅप क्रमांक <span>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-input webinar-form"
                      maxLength={10}
                      id="mobileNumber"
                      value={contactData?.mobileNumber}
                      onChange={handleChange}
                      placeholder="व्हॉट्सअ‍ॅप क्रमांक "
                    />
                    {error && (contactData?.mobileNumber === null || contactData?.mobileNumber === undefined || contactData?.mobileNumber === "") ? <span className="text-danger" style={{ fontSize: '14px' }}>{ERROR_MESSAGES}</span> : (error && (contactData?.mobileNumber !== null && contactData?.mobileNumber !== "" && contactData?.mobileNumber !== undefined && contactData?.mobileNumber?.length !== 10)) ? <span className="text-danger" style={{ fontSize: '14px' }}>Invalid Mobile Number</span> : ""}
                  </div>

                  {/* Email */}
                  <div className="col-md-6 col-webinarmarathi ">
                    <label className="form-label-custom webinar-label">
                      ई-मेल <span>*</span>
                    </label>
                    <input
                      value={contactData?.email}
                      type="email"
                      id="email"
                      onChange={handleChange}
                      className="form-input webinar-form"
                      placeholder="ई-मेल"
                    />
                    {error && (contactData?.email === null || contactData?.email === undefined || contactData?.email === "") ? <span className="text-danger" style={{ fontSize: '14px' }}>{ERROR_MESSAGES}</span> : (error && (contactData?.email !== null && contactData?.email !== undefined && contactData?.email !== "" && !validateEmail(contactData?.email))) ? <span className="text-danger" style={{ fontSize: '14px' }}>Invalid Email ID</span> : ''}
                  </div>
                </div>

                {/* Submit */}
                <div className="mt-0 text-start">
                  <button
                    type="submit"
                    className="careox-btn wbinar-form submit-button"
                    onClick={() => handleContactFormSubmit()}
                  >
                    <span>सबमिट</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="donate-page">
        <div className="container">
          <div className="row">
            {/* Left Column: Donation Form */}
            <div className="col-lg-8">
              <div className="donate-page__content">
                <div className="donate-page__notice p-4 rounded shadow-sm bg-light border">
                  <div className="donate-page__notice__icon mb-3"></div>

                  <div className="ganesh-rituals">
                    <h6
                      className="sec-title__tagline bw-split-in-right"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                      }}
                    >
                      <img className="tagline-img" src={batuk} alt="" />
                      गणेशोत्सवाचा सुंदर आरंभ!
                    </h6>
                    <h3 className="fw-bold mb-3 text-primary mane-webinarhead">
                      गणपती बाप्पा मोरया – पूजा विधींचं संपूर्ण मार्गदर्शन
                    </h3>
                    <p className="webinar-paragraph">
                      आजच्या धकाधकीच्या आयुष्यातही तुमच्या धार्मिक आणि
                      आध्यात्मिक गरजा पूर्ण करणे सोपे झाले आहे — माय ओम नमोच्या
                      मदतीने! दर्शन, वैयक्तिक गुरुजींची सेवा, आणि अगदी सोयीस्कर
                      पूजा किट्ससह सर्व काही तुम्हाला घरी बसल्या मिळू शकते.
                      अनुभवसंपन्न, प्रामाणिक आणि पारंपरिक पंडितांच्या
                      मार्गदर्शनाखाली तुमच्या संस्कृतीचे जतन आणि मनःशांतीची
                      अनुभूती घ्या. माय ओम नमो तुम्हाला पुरवते २७+ विविध
                      आध्यात्मिक सेवा, ज्यामध्ये ऑनलाइन पूजा बुकिंग,
                      ज्योतिषशास्त्र, वास्तु सल्ला, ध्यान, योग, मंदिर दर्शन, आणि
                      इतर अनमोल सेवा आहेत. तुम्ही कुठेही असलात तरी, आपल्या घराचा
                      देवमय अनुभव आम्ही तुमच्या दारात पोहोचवतो. आध्यात्मिक
                      उन्नतीसाठी आणि आयुष्यात स्थिरतेसाठी माय ओम नमो तुमच्या
                      विश्वासू साथीदाराप्रमाणे काम करते. त्यामुळे आता वेळ नाही
                      म्हणून पूजा, दर्शन, आणि आध्यात्मिक सल्ला मागे टाकू नका —
                      आजच माय ओम नमो वापरा आणि तुमच्या घरात देवाच्या आशीर्वादाने
                      भरलेला शांतिपूर्ण आणि समृद्ध जीवनाचा आनंद अनुभवायला
                      सुरुवात करा! माय ओम नमोसोबत तुमचा प्रत्येक दिवस भक्तीमय
                      आणि आनंदमय बनवा. आता भक्ती, श्रद्धा आणि समाधान एकाच ठिकाणी
                      — तुमच्या मोबाईलवर.
                    </p>
                    <h5>माय ओम नमोच्या २७ प्रमुख सेवा:</h5>
                    <div className="grid-container">
                      <div className="list-column">
                        <ul>
                          <li>
                            विद्वान आणि प्रामाणिक पंडितांसह ऑनलाइन पूजा बुकिंग
                          </li>
                          <li>भजन-कीर्तनासाठी ऑनलाइन बुकिंग</li>
                          <li>दैनिक पंडित सेवा (घरी/ऑफिसमध्ये पूजा)</li>
                          <li>ई-स्टोअर (पूजा समाग्री आणि आध्यात्मिक वस्तू)</li>
                          <li>ज्योतिष सेवा</li>
                          <li>वास्तु सल्ला</li>
                          <li>अंकशास्त्र सेवा</li>
                          <li>टॅरो कार्ड वाचन</li>
                          <li>हस्तरेखा विश्लेषण</li>
                          <li>ध्यान केंद्र बुकिंग</li>
                        </ul>
                      </div>
                      <div className="list-column">
                        <ul>
                          <li>ब्राह्मण भोज व्यवस्थापन</li>
                          <li>अंत्यसंस्कार सेवा</li>
                          <li>श्राद्ध सेवा</li>
                          <li>तीर्थयात्रा व्यवस्थापन</li>
                          <li>ऑनलाइन मंदिर दक्षिणा</li>
                          <li>ऑनलाइन प्रसाद वितरण</li>
                          <li>आध्यात्मिक ब्लॉग व ज्ञान</li>
                          <li>आभासी पूजा सेवा</li>
                          <li>संपूर्ण पूजा व्यवस्थापन (अन्नासहित)</li>
                          <li>आध्यात्मिक कार्यक्रम व्यवस्थापन</li>
                          <li>पुरोहितांसाठी प्रमाणपत्र कार्यक्रम</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column: Swiper Carousel */}
            <div className="col-lg-4">
              <div className="donate-page__sidebar">
                <Swiper
                  modules={[Autoplay, Navigation]}
                  spaceBetween={30}
                  slidesPerView={1}
                  // autoplay={{ delay: 3000, disableOnInteraction: false }}
                  navigation={true}
                >
                  {slides.map((slide, index) => (
                    <SwiperSlide key={index}>
                      <div
                        className="donations-one__item"
                        style={{ "--accent-color": slide.color }}
                      >
                        <div className="donations-one__item__image">
                          <img src={AbuotUs} alt="careox" />
                          <a
                            href="donation-details.html"
                            className="donations-one__item__image__link"
                          ></a>
                        </div>

                        <div className="donations-one__item__content">
                          <h6
                            className="sec-title__tagline bw-split-in-right addingheading-webinar"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "start",
                            }}
                          >
                            गणेश पूजेची योग्य पद्धत जाणून घ्या!
                          </h6>

                          <ul className="donation-details__author__list">
                            <li>
                              <i className="icofont-ui-calendar"></i> गणेश
                              चतुर्थी : २७ ऑगस्ट २०२५
                            </li>
                            <li>
                              <i className="icofont-ui-calendar"></i> वेबिनार
                              दिनांक : १८ ऑगस्ट २०२५
                            </li>
                            <li>
                              <i className="icofont-clock-time"></i> वेळ : सकाळी
                              ११:०० ते दुपारी १:३०
                            </li>
                            <li>
                              <i className="icofont-flag"></i> भाषा : मराठी
                            </li>
                            <li>
                              <i className="icofont-money"></i> शुल्क : ₹५१
                            </li>
                            <li>
                              <i className="icofont-video-cam"></i> प्लॅटफॉर्म :
                              Zoom
                            </li>
                          </ul>

                          <button
                            type="submit"
                            className="careox-btn button-webinar"
                            style={{ margin: "20px" }}
                            onClick={() => HandleJoinNowClicked()}
                          >
                            <span>नोंदणी करा</span>
                          </button>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* End of Donate Section */}

      <LazySection>
        <FAQSection languageID={1} />
      </LazySection>
      <DownloadApp languageID={1} />
      <ComingSoonModal
        show={showComingSoonModal}
        onClose={() => setShowComingSoonModal(false)}
        moduleName='m-webinar'
      />
    </>
  );
};

export default WebinarLandingPage;
